import Dashboard from "views/Dashboard/Dashboard.js";
import Product from "views/Product.js";
import Transactions from "views/Transactions.js";
import SalesReport from "views/SalesReport.js";
import Promotion from "views/Promotion.js";
import Settings from "views/Settings.js";
import Machines from "views/Machines.js";
import Advertising from "views/Advertising.js";
import ActivitiesLogs from "views/ActivitiesLogs.js";
import { AiOutlineDashboard } from "react-icons/ai";
import { PiHandbagBold } from "react-icons/pi";
import { AiOutlineTransaction } from "react-icons/ai";
import { FaChartBar } from "react-icons/fa";
import { LuPackageOpen } from "react-icons/lu";
import { HiOutlineSpeakerphone } from "react-icons/hi";
import { IoGiftOutline } from "react-icons/io5";
import { AiOutlineHistory } from "react-icons/ai";
import { IoSettingsOutline } from "react-icons/io5";
import { MdOutlineList, MdAdd, MdCategory, MdPending, MdHistory } from "react-icons/md";
import { BiListUl } from "react-icons/bi";
import { IoCheckboxOutline } from "react-icons/io5";
import { MdOutlineVideoLibrary } from "react-icons/md";
import CreativeVideoAssignments from "views/CreativeVideoAssignments";
import CurrencyConverter from "views/CurrencyConverter";
import { BiDollarCircle } from "react-icons/bi";




const nav_ = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: <AiOutlineDashboard />,
    component: Dashboard,
    layout: "/admin"
  },
  {
    path: "/product",
    name: "Product/Category",
    icon: <PiHandbagBold />,
    component: Product,
    layout: "/admin",
    dropdown: [
      { path: "/product/categories", name: "Categories", icon: <MdCategory />, layout: "/admin" },
      { path: "/product/list", name: "Product List", icon: <MdOutlineList />, layout: "/admin" },
      // { path: "/product/add", name: "Add Product", icon: <MdAdd />, layout: "/admin" },
    ]
  },
  {
    path: "/machines",
    name: "Machines",
    icon: <LuPackageOpen />,
    component: Machines,
    layout: "/admin",
    dropdown: [
      { path: "/machines/list", name: "Machine List", icon: <BiListUl />, layout: "/admin" },
      // { path: "/machines/add", name: "Add Machine", icon: <MdAdd />, layout: "/admin" },
      { path: "/machines/status", name: "Machine Status", icon: <IoCheckboxOutline />, layout: "/admin" }
    ]
  },
  {
    path: "/transactions",
    name: "Transactions",
    icon: <AiOutlineTransaction />,
    component: Transactions,
    layout: "/admin",
    dropdown: [
      { path: "/transactions/list", name: "Transaction List", icon: <MdOutlineList />, layout: "/admin" },
      { path: "/transactions/pending", name: "Pending Transactions", icon: <MdPending />, layout: "/admin" },
      // { path: "/transactions/history", name: "Transaction History", icon: <MdHistory />, layout: "/admin" }
    ]
  },
  {
    path: "/sales-report",
    name: "Sales Report",
    icon: <FaChartBar />,
    component: SalesReport,
    layout: "/admin"
  },
  {
    path: "/creative/videos",
    name: "Creative  Management",
    icon: <MdOutlineVideoLibrary />,
    component: CreativeVideoAssignments,
    layout: "/admin"
  },
  {
    path: "/currency-converter",
    name: "Currency Converter",
    icon: <BiDollarCircle />,
    component: CurrencyConverter,
    layout: "/admin"
  },
  // {
  //   path: "/advertising",
  //   name: "Advertising",
  //   icon: <HiOutlineSpeakerphone />,
  //   component: Advertising,
  //   layout: "/admin"
  // },
  // {
  //   path: "/promotion",
  //   name: "Promotion",
  //   icon: <IoGiftOutline />,
  //   component: Promotion,
  //   layout: "/admin"
  // },
  // {
  //   path: "/activities-logs",
  //   name: "Activities Logs",
  //   icon: <AiOutlineHistory />,
  //   component: ActivitiesLogs,
  //   layout: "/admin"
  // },
  {
    path: "/settings",
    name: "Settings",
    icon: <IoSettingsOutline />,
    component: Settings,
    layout: "/admin",
  },
];

export default nav_;
